export default __webpack_public_path__ + "static/media/3b2e37552d2c59ad.6176b6313a705dc3be0a33442f56e837.svg";